import { styled, Switch } from "@mui/material";

import { TOGGLE_GREEN } from "../../constants/colors";

export const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 35,
  height: 18,
  padding: 0,
  marginLeft: 40,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
      height: 15,
      color: "#fff",
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(0px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: TOGGLE_GREEN,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 15,
    height: 15,
    borderRadius: 8,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    opacity: 1,
    backgroundColor: "rgba(27, 18, 18, 0.22)",
    boxSizing: "border-box",
    ...theme.applyStyles("dark", {
      backgroundColor: "rgba(255,255,255,.35)",
    }),
  },
}));
